import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CalendarModalState } from '../../models/calendar.models';
import { CoreService } from 'src/app/core/helpers/core.service';
import { TranslateModule } from '@ngx-translate/core';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { AuthService } from 'src/app/core/helpers/auth.service';

@Component({
  selector: 'loyaltic-reward-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './reward-modal.component.html',
  styleUrls: ['./reward-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RewardModalComponent {
  @Input() modal: CalendarModalState | null = null;
  @Output() closed = new EventEmitter<boolean>();
  videoAnimationLink = '';
  @Input() isAnimationLoading;
  animationLoaded = true;
  showClaimModal = false;
  winDetails: any;
  hasGame = false;
  showSurvey = true;

  constructor(public coreService: CoreService, 
    private authService: AuthService,
    private cdr: ChangeDetectorRef, 
    private dataService: DataServiceService) {
      if(localStorage.getItem('surveyTaken') == 'true') {
      this.showSurvey = false;
    }
  }

  ngOnInit() {
    this.isAnimationLoading = true;
    this.winDetails = this.dataService.winDetails;
  }

  ngAfterViewInit() {
    this.videoAnimationLink = this.coreService.videoAnimationLink;
  }

  surveyTaken() {
    localStorage.setItem('surveyTaken','true')
  }

  get isOpen(): boolean {
    this.videoAnimationLink = this.coreService.videoAnimationLink;
    this.winDetails = this.dataService.winDetails;
    return Boolean(this.modal?.open);
  }

  get isLoading(): boolean {
    return Boolean(this.modal?.loading);
  }

  get isWin(): boolean {
    return Boolean(this.modal?.result?.won);
  }

  get result() {
    return this.modal?.result;
  }

  onWinAnimationEnd() {
    if (!this.isWin) {
      this.isAnimationLoading = false;
    }
    
    this.CheckGames();
    this.cdr.detectChanges();
  }

  CheckGames() {
    const userId = this.authService.getUserId();
    this.coreService.hasGames(userId).subscribe((response:any) => {
      this.hasGame = response.result.hasGames;
      this.coreService.hasGame = response.result.hasGames;
      this.cdr.detectChanges();
      if (this.isWin) {
        this.showClaim();
      }
    })
  }

  onClose(): void {
    this.isAnimationLoading = true;
    this.closed.emit(false);
    this.coreService.loadResponse();
  }

  showClaim() {
    this.isAnimationLoading = true;
    this.closed.emit(true);
    this.coreService.loadResponse();
  }

  @HostListener('document:keydown.escape')
  handleEscape(): void {
    if (this.isOpen) {
      this.onClose();
    }
  }
}
